import { i18n } from "../src/plugins/i18n";

const content = {
  days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  tabs: {
    fleet_report: {
      id: "fleet_report",
      route: "/poi",
      icon: "home",
      name: "POIReport",
    },
    pois: {
      id: "pois",
      route: "/locations",
      icon: "location_on",
      name: "Locations",
    },
    journeys: {
      id: "journeys",
      route: "/journeys",
      icon: "local_shipping",
      name: "Journeys",
    },
    devices: {
      id: "devices",
      route: "/devices",
      icon: "device_hub",
      name: "Devices",
    },
    report: {
      id: "report",
      route: "/report",
      icon: "mdi-file-document-outline",
      name: "Report",
    },
    settings: {
      id: "settings",
      route: "/alerts",
      icon: "mdi-bell",
      name: "Alerts",
    },
    powercoil_analytics: {
      id: "powercoil_analytics",
      route: "/powercoil_analytics",
      icon: "analytics",
      name: "Analytics",
    },
    powercoil_devices: {
      id: "powercoil_devices",
      route: "/assets",
      icon: "sensors",
      name: "Assets",
    },
    powercoil_report: {
      id: "powercoil_report",
      route: "/powercoil_report",
      icon: "mdi-file-document-outline",
      name: "Powercoil_Report",
    },
    powercoil_alerts: {
      id: "powercoil_alerts",
      route: "/powercoil_alerts",
      icon: "mdi-bell",
      name: "Powercoil_Alerts",
    },
    powercoil_ev: {
      id: "powercoil_ev",
      route: "/powercoil_ev",
      icon: "mdi-chart-line-stacked",
      name: "Powercoil_EVM",
    },
  },
  no_header_route_names: [
    "report_fleet",
    "report_kpi",
    "POISnapshot",
    "Asset_Snapshot",
    "Error",
    "Device_Test",
    "Device_Coverage",
    "Report_Snapshot",
    "AccessDenied",
  ],
  DeviceStatus: {
    color: {
      Active: "success",
      Inactive: "secondary",
      Installed: "vtblue",
      Registered: "lightCoral",
      Provisioned: "secondary",
      Unknown: "borderLight",
      "Not Installed": "vtred",
    },
    tooltip: {
      Fluid: "Assets which are moving across POIs within a pre-defined time period",
      Static: "Assets which have been at the same POI for more than a pre-defined time period",
      Installed: "Installed Devices",
      Registered: "Registered Devices",
      Provisioned: "Provisioned Devices",
      Unknown: "Unknown Devices",
      "Not Installed": "Devices yet to be installed.",
    },
  },
  Priority: {
    color: {
      1: "vtred",
      2: "orange",
      3: "yellow",
      4: "lightYelow",
    },
  },
  eventType: {
    color: {
      LOSS_OF_MAINS: "pink",
      INTERRUPT: "indigo",
      RAPID_VOLTAGE_CHANGE: "deep-purple",
      FLICKER: "amber",
      DIP: "red",
      SWELL: "blue",
    },
  },
  type: {
    color: {
      Fault: "vtred",
      Event: "orange",
    },
  },
  hasIssues: {
    color: {
      check: "blue",
      caution: "yellow",
      noIssues: "green",
      alarm: "red",
    },
  },
  issues: {
    HasCapacityUnderLimit: {
      label: i18n.t("views.Analytics.charts.issues.hAxis.HasCapacityUnderLimit.label"),
      tooltip: i18n.t("views.Analytics.charts.issues.hAxis.HasCapacityUnderLimit.tooltip"),
      icon: "mdi-alert",
    },
    HasCapacityOverLimit: {
      label: i18n.t("views.Analytics.charts.issues.hAxis.HasCapacityOverLimit.label"),
      tooltip: i18n.t("views.Analytics.charts.issues.hAxis.HasCapacityOverLimit.tooltip"),
      icon: "mdi-alert",
    },
    HasMissedMessages: {
      label: i18n.t("views.Analytics.charts.issues.hAxis.HasMissedMessages.label"),
      tooltip: i18n.t("views.Analytics.charts.issues.hAxis.HasMissedMessages.tooltip"),
      icon: "mdi-message-alert",
    },
    HasImbalance: {
      label: i18n.t("views.Analytics.charts.issues.hAxis.HasImbalance.label"),
      tooltip: i18n.t("views.Analytics.charts.issues.hAxis.HasImbalance.tooltip"),
      icon: "mdi-chart-line",
    },
    HasCurrentOverLimit: {
      label: i18n.t("views.Analytics.charts.issues.hAxis.HasCurrentOverLimit.label"),
      tooltip: i18n.t("views.Analytics.charts.issues.hAxis.HasCurrentOverLimit.tooltip"),
      icon: "mdi-current-ac",
    },
    HasLowBattery: {
      label: i18n.t("views.Analytics.charts.issues.hAxis.HasLowBattery.label"),
      tooltip: i18n.t("views.Analytics.charts.issues.hAxis.HasLowBattery.tooltip"),
      icon: "mdi-battery-10",
    },
    HasNoPower: {
      label: i18n.t("views.Analytics.charts.issues.hAxis.HasNoPower.label"),
      tooltip: i18n.t("views.Analytics.charts.issues.hAxis.HasNoPower.tooltip"),
      icon: "mdi-power-plug-off",
    },
    HasTemperatureOutsideRange: {
      label: i18n.t("views.Analytics.charts.issues.hAxis.HasTemperatureOutsideRange.label"),
      tooltip: i18n.t("views.Analytics.charts.issues.hAxis.HasTemperatureOutsideRange.tooltip"),
      icon: "mdi-thermometer-lines",
    },
    HasTemperatureOverLimit: {
      label: i18n.t("views.Analytics.charts.issues.hAxis.HasTemperatureOverLimit.label"),
      tooltip: i18n.t("views.Analytics.charts.issues.hAxis.HasTemperatureOverLimit.tooltip"),
      icon: "mdi-thermometer-high",
    },
    HasTemperatureSenseError: {
      label: i18n.t("views.Analytics.charts.issues.hAxis.HasTemperatureSenseError.label"),
      tooltip: i18n.t("views.Analytics.charts.issues.hAxis.HasTemperatureSenseError.tooltip"),
      icon: "mdi-thermometer-alert",
    },
  },
  duval_error: {
    t1_error: {
      label: "",
      tooltip: "",
      icon: "mdi-alert",
    },
    t2_error: {
      label: "",
      tooltip: "",
      icon: "mdi-alert",
    },
    t3_error: {
      label: "",
      tooltip: "",
      icon: "mdi-alert",
    },
  },
  map_legends: [
    {
      label: "Friendly POI",
      color: "midnightBlue",
    },
    {
      label: "Non-Friendly POI",
      color: "lightCoral",
    },
    {
      label: "Device Outside Known POI",
      color: "orangered",
    },
  ],
  map_powercoil_legends: [
    {
      label: "No Issues",
      color: "midnightBlue",
    },
    {
      label: "With Issues",
      color: "lightCoral",
    },
  ],
  map_rollout_legends: [
    {
      label: "Installed",
      color: "vtblue",
    },
    {
      label: "Registered",
      color: "lightCoral",
    },
    {
      label: "Provisioned",
      color: "secondary",
    },
    {
      label: "Unknown",
      color: "borderLight",
    },
    {
      label: "Not Installed",
      color: "vtred",
    },
  ],
  rollout_status: {
    Installed: "vtblue",
    "Not Installed": "vtred",
    Registered: "lightCoral",
    Provisioned: "secondary",
    Unknown: "borderLight",
  },
  DeviceType: {
    color: {
      Tracking: "primaryGrey",
    },
  },
  PowerDataDeviceType: {
    Current0Max: "Max Current PH1",
    Current0Med: "Med Current PH1",
    Current1Max: "Max Current PH2",
    Current1Med: "Med Current PH2",
    Current2Max: "Max Current PH3",
    Current2Med: "Med Current PH3",
    TemperatureMax: "Max Temperature",
    TemperatureMed: "Med Temperature",
  },
  BatteryStatus: {
    color: {
      High: "success",
      Low: "secondary",
      Unknown: "error",
      null: "primaryGrey",
    },
  },
  UpdatedSeqNo: {
    highlight: {
      GPRS: "font-weight-bold",
      LTE: "font-weight-bold",
    },
  },
  ActivityLevel: {
    color: {
      High: "success",
      Mid: "secondary",
      Low: "error",
    },
  },
  LastMessageType: {
    color: {
      TwoWifi: "primaryDark",
      TwoWiFi: "primaryDark",
      OneWiFi: "primaryOutline",
      OneWifi: "primaryOutline",
      gps: "primaryGrey",
      DownlinkAcknowledgement: "success",
      "DL Ack": "success",
      None: "error",
      NoPositionData: "error",
    },
    icon: {
      TwoWifi: "mdi-wifi-strength-4",
      TwoWiFi: "mdi-wifi-strength-4",
      OneWiFi: "mdi-wifi-strength-2",
      OneWifi: "mdi-wifi-strength-2",
      gps: "mdi-crosshairs-gps",
      DownlinkAcknowledgement: "mdi-arrow-down-box",
      "DL Ack": "mdi-arrow-down-box",
      None: "mdi-block-helper",
      NoPositionData: "mdi-map-marker-off-outline",
    },
  },
  AcceleratedAgeing: {
    color: {
      false: "noIssuesText",
      true: "alarmText",
    },
    icon: {
      true: "mdi-alert-circle-outline",
      false: "mdi-check-circle",
    },
  },
  Ageing: {
    color: {
      AcceleratedAgeing: "alarmText",
      FutureAgeing: "alarmText",
      undefined: "noIssuesText",
    },
    icon: {
      AcceleratedAgeing: "mdi-calendar-remove",
      FutureAgeing: "mdi-calendar-remove",
      undefined: "mdi-check-circle",
    },
    tooltip: {
      AcceleratedAgeing: "Accelerated Ageing",
      FutureAgeing: "Future Ageing",
      undefined: "No Issues",
    },
  },
  Hydrogen: {
    color: {
      HydrogenAlert: "alarmText",
      HydrogenRateOfChangeAlert: "alarmText",
      undefined: "noIssuesText",
    },
    icon: {
      HydrogenAlert: "mdi-alert",
      HydrogenRateOfChangeAlert: "mdi-trending-up",
      undefined: "mdi-check-circle",
    },
    tooltip: {
      HydrogenAlert: "Hydrogen Alert",
      HydrogenRateOfChangeAlert: "Hydrogen Rate Of Change Alert",
      undefined: "No Issues",
    },
  },
  RiskOfOverload: {
    color: {
      RiskOfOverload: "alarmText",
      ReRating: "alarmText",
      undefined: "noIssuesText",
    },
    icon: {
      RiskOfOverload: "mdi-alert-octagon",
      ReRating: "mdi-alert-octagon",
      undefined: "mdi-check-circle",
    },
    tooltip: {
      RiskOfOverload: "Risk Of Overload",
      ReRating: "Re-Rating",
      undefined: "No Issues",
    },
  },
  AssetReplacementMaintenance: {
    color: {
      Replacement: "alarmText",
      Maintenance: "alarmText",
      Temperature: "alarmText",
      undefined: "noIssuesText",
    },
    icon: {
      Replacement: "mdi-wrench",
      Maintenance: "mdi-auto-fix",
      Temperature: "mdi-thermometer",
      undefined: "mdi-check-circle",
    },
    tooltip: {
      Replacement: "Replacement",
      Maintenance: "Maintenance",
      Temperature: "Temperature",
      undefined: "No Issues",
    },
  },
  MessageType: {
    color: {
      TwoWifi: "primaryDark",
      TwoWiFi: "primaryDark",
      OneWiFi: "primaryOutline",
      OneWifi: "primaryOutline",
      gps: "primaryGrey",
      DownlinkAcknowledgement: "success",
      "DL Ack": "success",
      None: "error",
      NoPositionData: "error",
    },
    icon: {
      TwoWifi: "mdi-wifi-strength-4",
      TwoWiFi: "mdi-wifi-strength-4",
      OneWiFi: "mdi-wifi-strength-2",
      OneWifi: "mdi-wifi-strength-2",
      gps: "mdi-crosshairs-gps",
      DownlinkAcknowledgement: "mdi-arrow-down-box",
      "DL Ack": "mdi-arrow-down-box",
      None: "mdi-block-helper",
      NoPositionData: "mdi-map-marker-off-outline",
    },
  },
  LastMessageTypeAtKnownLocation: {
    color: {
      TwoWifi: "primaryDark",
      TwoWiFi: "primaryDark",
      OneWiFi: "primaryOutline",
      OneWifi: "primaryOutline",
      gps: "primaryGrey",
      DownlinkAcknowledgement: "success",
      "DL Ack": "success",
      None: "error",
      NoPositionData: "error",
    },
    icon: {
      TwoWifi: "mdi-wifi-strength-4",
      TwoWiFi: "mdi-wifi-strength-4",
      OneWiFi: "mdi-wifi-strength-2",
      OneWifi: "mdi-wifi-strength-2",
      gps: "mdi-crosshairs-gps",
      DownlinkAcknowledgement: "mdi-arrow-down-box",
      "DL Ack": "mdi-arrow-down-box",
      None: "mdi-block-helper",
      NoPositionData: "mdi-map-marker-off-outline",
    },
  },
  LocationType: {
    color: {
      Friendly: "primaryOutline",
      "Non-Friendly": "error",
      "Non Friendly": "error",
      "Outside POIs": "secondary",
      "No location data": "secondary",
    },
    icon: {
      Friendly: "mdi-certificate-outline",
      "Non-Friendly": "mdi-mdi-",
      "Non Friendly": "mdi-mdi-",
      "Outside POIs": "mdi-card-bulleted-off-outline",
      "No location data": "mdi-card-bulleted-off-outline",
    },
    tooltip: {
      Friendly: " POIs which you have marked as friendly locations",
      "Non-Friendly": "POIs which you have marked as non-friendly locations",
      "Non Friendly": "POIs which you have marked as non-friendly locations",
      "Outside POIs": "Devices which are not at a saved/known POI",
      "No location data": "Devices which have not sent location data in a communication message",
    },
  },
  IsWatchlisted: {
    icon: {
      true: "mdi-star",
      false: "mdi-star-outline",
    },
  },
  InstallationStatus: ["Not Installed", "Installed"],
  powerdata: {
    tabs: [
      {
        label: "Charts",
        id: "charts",
      },
      {
        label: "Messages",
        id: "messages",
      },
      {
        label: "Trends Data",
        id: "rms_data",
      },
      {
        label: "Events",
        id: "events",
      },
      {
        label: "Fault Records",
        id: "faults",
      },
      {
        label: "XFRMR Health",
        id: "xfrmr",
      },
      {
        label: "Metering",
        id: "metering",
      },
      {
        label: "Images",
        id: "images",
      },
    ],
  },
  events: {
    LOSS_OF_MAINS: "Fault",
    INTERRUPT: "Event",
    RAPID_VOLTAGE_CHANGE: "Event",
    DIP: "Event",
    SWELL: "Event",
    FLICKER: "Event",
  },
  events_config: {
    LOSS_OF_MAINS: "Loss Of Mains",
    INTERRUPT: "Interrupt",
    RAPID_VOLTAGE_CHANGE: "Rapid Voltage Change",
    DIP: "Dip",
    SWELL: "Swell",
    FLICKER: "Flicker",
  },
  h2_oiltype: [
    { label: "Mineral", value: "Mineral" },
    { label: "Natural Ester", value: "Natural Ester" },
    { label: "Synthetic Ester", value: "Synthetic Ester" },
  ],
  h2_opmode: [{ label: "Field", value: "Field" }],
  H2SensorType: [
    { label: "Sealed", value: "Sealed" },
    { label: "Open", value: "Open" },
  ],
  H2SensorLocation: [
    { label: "Main Tank", value: "MainTank" },
    { label: "OLTC", value: "OLTC" },
    { label: "Bushing", value: "Bushing" },
    { label: "CT-PT", value: "CT-PT" },
    { label: "Cable", value: "Cable" },
    { label: "Top Oil", value: "TopOil" },
  ],
  Status: {
    0: "Not Ready",
    1: "Error",
    2: "Ready H₂ readings valid (old data)",
    3: "Ready H₂ readings valid (new data)",
  },
  Operation: {
    0: "Undetermined",
    1: "H₂ measurement cycle",
    2: "Liquid temp meas cycle",
    3: "Auto calibration cycle",
    4: "Liquid temp too high",
  },
  DeviceTypes: {
    "Ground Mount": {
      label: "Ground Mount",
      value: "Ground Mount",
      icon: "mdi-square",
      color: "primary",
    },
    "Pole Mount": {
      label: "Pole Mount",
      value: "Pole Mount",
      icon: "mdi-circle",
      color: "secondary",
    },
    Indoor: {
      label: "Indoor",
      value: "Indoor",
      icon: "mdi-rhombus",
      color: "success",
    },
  },
  ConnectionType: ["P.L.T.E", "Public Sim"],
  MissedMessageTypes: {
    good: {
      icon: "mdi-shield-check-outline",
      color: "noIssuesText",
    },
    average: {
      icon: "mdi-shield-alert-outline",
      color: "cautionText",
    },
    bad: {
      icon: "mdi-shield-off-outline",
      color: "alarmText",
    },
  },
  TemperatureMetric: {
    celsius: { text: "Celsius", value: "celsius", suffix: "°C" },
    fahrenheit: { text: "Fahrenheit", value: "fahrenheit", suffix: "°F" },
  },
  URLShareProps: [
    { id: "date", label: "Date" },
    { id: "current_tab", label: "Current Tab" },
  ],
};

export { content };
